import { useState } from 'react';
import { Plus, Upload } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useFinance } from '@/contexts/FinanceContext';
import { TransactionList } from './TransactionList';
import { TransactionModal } from './TransactionModal';
import { ImportWizard } from './import/ImportWizard';
import { useCurrentClient } from '@/hooks/useCurrentClient';
import { InstructionTrigger } from '@/features/instructions/InstructionDrawer';

export function TransactionsPage() {
  const { clientId } = useCurrentClient();
  const { accounts } = useFinance();
  const [modalOpen, setModalOpen] = useState(false);
  const [importOpen, setImportOpen] = useState(false);

  if (!clientId) {
    return (
      <div className="rounded-xl border border-border bg-white p-8 text-center text-muted-foreground">
        <p className="text-sm">Selecione um cliente para ver as transações.</p>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h1 className="font-brand text-2xl font-bold text-foreground">Transações</h1>
          <p className="text-sm text-muted-foreground">
            Contas a pagar e receber ·{' '}
            <InstructionTrigger contextKey="bulk-actions" variant="inline" label="Ações em lote" />
          </p>
        </div>
        <div className="flex items-center gap-2">
          <InstructionTrigger contextKey="import-ofx" variant="ghost" label="" iconSize={14} />
          <Button
            variant="outline"
            onClick={() => setImportOpen(true)}
            disabled={accounts.length === 0}
          >
            <Upload size={16} className="mr-2" />
            Importar
          </Button>
          <Button
            onClick={() => setModalOpen(true)}
            disabled={accounts.length === 0}
            className="bg-accent font-semibold text-accent-foreground hover:bg-accent/90"
          >
            <Plus size={16} className="mr-2" />
            Nova Transação
          </Button>
        </div>
      </div>

      {accounts.length === 0 ? (
        <div className="rounded-xl border border-border bg-white p-8 text-center text-muted-foreground">
          <p className="text-sm">
            Cadastre pelo menos uma conta bancária antes de lançar transações.
          </p>
        </div>
      ) : (
        <TransactionList />
      )}

      <TransactionModal open={modalOpen} onOpenChange={setModalOpen} />
      <ImportWizard open={importOpen} onClose={() => setImportOpen(false)} />
    </div>
  );
}
